/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { Row, Col, Image, Space } from "antd";
import { Button, TextField, Box, FormControlLabel, Switch } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import MainHeader from "../../../../Shared/components/Header";
import { toast } from 'react-toastify';
import clsx from "clsx";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import actions from "../../redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import { ListTable } from './ListTable';
import { CopyRole } from './CopyRole';
import usePrevious from "../../../../Shared/components/Previous";
import { emptyValidation } from "../../../../../helpers/validation";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import CopyIcon from "../../../../../assets/images/icon_actions/Copy Icon.svg";
import { NavLink } from "react-router-dom";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { checkViewPermission, checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';

const SecurityRoles = (props) => {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { loader } = useSelector(state => state.younoteAdminSecuritySetupReducer);
    const { createDetails, createError, createLoader, editDetails, editError, editLoader, getList, getData } = useSelector(state => state.crudReducer);
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [visible, setVisible] = useState(false);
    const [copyVisible, setCopyVisible] = useState(false);
    const [errorName, setErrorName] = useState(false);

    const { history } = props;

    const [addMore, setAddMore] = useState(false);
    const [roleId, setRoleId] = useState(false);
    const [name, setName] = useState('');

    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);

    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [deleteModal, setDeleteModal] = useState(false);

    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [importVisible, setImportVisible] = useState(false);

    const dispatch = useDispatch();

    const [form, setForm] = useState({
        name: "",
        globalRole: false
    });

    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");


    const classes = customStyles();

    const handleOpen = () => {
        setVisible(true);
        emptyStateInput();
        emptyState();
    };
    const handleClose = () => {
        setVisible(false);
        emptyStateInput();
        emptyState();
    };

    const changeHandler = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const loadTasks = useCallback(() => {
        dispatchFilter(sortBy, sortOrder);
        dispatch({
            type: actions.ROLE_DETAILS_START,
            url: 'role',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    });


    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Security Roles', history, 'Younote Admin')) {
                loadTasks();
            }
        }
    }, [roleManagement]);


    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'role',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            },
        });
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);


    const createComponent = (e) => {
        e.preventDefault();
        let emptyName = emptyValidation('name', form.name);
        if (emptyName.isValid) {
            delete form.percentage;
            dispatch({
                type: roleId === '' ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
                url: 'role',
                title: 'Role',
                id: roleId,
                details: form
            });
        } else {
            if (emptyName.errors) {
                setErrorName(emptyName.errors);
            }
        }
    }

    const emptyStateInput = () => {
        setForm({
            name: "",
            globalRole: false
        });
        setRoleId('');
    };

    const emptyState = () => {
        setErrorName(false);
    };

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            loadTasks();
            handleClose();
            toast.dismiss();
            toast(createDetails);
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message;
            setErrorName(error);
        }
    }, [createDetails, createError]);


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            loadTasks();
            handleClose();
            toast.dismiss();
            toast(editDetails);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let error = editError.error.message;
            setErrorName(error);
        }
    }, [editDetails, editError]);

    const onEdit = (data) => {
        setVisible(true);
        setRoleId(data.id);
        setForm({
            name: data.name,
            globalRole: data.globalRole
        });
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setRoleId(data.id);
        setName(data.name);
    };

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const handleAddMore = (e) => {
        createComponent(e);
        setAddMore(true);
    }

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    const handleGlobalRole = (value) => {
        setForm({
            ...form,
            "globalRole": !value,
        });
    }

    const handleCopyRole = () => {
        setCopyVisible(true);
    }

    const handleCopyClose = () => {
        setCopyVisible(false);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.ROLE_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'role',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    return (
        <React.Fragment>
            <MainHeader {...props} img={SettingsImg} title={'Younote Admin'}
                links={[{ 'label': 'Younote Admin', 'link': '/younote-admin' }, { 'label': 'Security Roles', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Security Roles'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Security Roles', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.allCustomerTop)}>
                                    <div className={classes.overlFlowResponsiveDesign}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Security Roles', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { loadImportExportData('Role'); }}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Security Roles', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { setImportVisible(true); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Security Roles', 'create', 'Younote Admin') &&
                                                <NavLink
                                                    to={"#"}
                                                    onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Role</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Security Roles', 'create', 'Younote Admin') &&
                                                <NavLink
                                                    to={"#"}
                                                    onClick={() => handleCopyRole()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={CopyIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage, classes.padding10Left)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Copy Role</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Security Roles', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ListTable
                                onEdit={(data) => onEdit(data)}
                                onDelete={(data) => onDelete(data)}
                                loadTasks={() => loadTasks()}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                roleManagement={roleManagement}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder} sortBy={sortBy}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
                <PrimaryDrawer
                    anchor={'right'}
                    open={visible}
                    variant={'temporary'}
                    handleClose={() => handleClose()}
                    title={`${roleId ? 'Edit' : 'Add'} Role`}
                    width={'360px'}
                    className={clsx(classes.closeBackGround, classes.width100P)}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            onSubmit={(e) => createComponent(e)}
                        >
                            <div className={classes.customFormFlex}>
                                <TextField autoComplete='one-time-code'
                                    label={["Role ", <span key={"Role"} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    error={errorName ? true : false}
                                    helperText={errorName}
                                    name={"name"}
                                    value={form.name}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => changeHandler(e)}
                                />
                                <div className={classes.textAlignLeft}>
                                    <FormControlLabel
                                        classes={{
                                            label: clsx(classes.fonSize13, 'MuiInputLabel-shrink', classes.textFieldLableColorCustom),
                                        }}
                                        control={<Switch size='small'
                                            className={clsx(classes.marginLeft10, classes.customSwitch)}
                                            onChange={(e) => { handleGlobalRole(form.globalRole) }} checked={form.globalRole}
                                        />}
                                        name={"globalRole"}
                                        label="Available for All Clients"
                                        labelPlacement="start"
                                        checked={form.globalRole}
                                        className={clsx(classes.margin30t, classes.flexStart,classes.marginLeft0)}
                                    />
                                </div>
                            </div>
                            <div className={clsx(classes.btnParent)}>
                                <Space direction="horizontal" align="center" size={[10, 10]}>
                                    <Button
                                        key="save"
                                        type='submit'
                                        color='primary'
                                        variant="contained"
                                        className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}
                                    >
                                        {
                                            roleId ? 'Update & Close' : 'Save & Close'
                                        }
                                    </Button>
                                    {
                                        !roleId && <Button
                                            key="add"
                                            onClick={(e) => handleAddMore(e)}
                                            color='primary'
                                            variant="contained"
                                            className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                        > Add more</Button>
                                    }
                                </Space>
                            </div>
                        </Box>
                    }
                />
                <CopyRole
                    copyVisible={copyVisible}
                    handleCopyClose={() => handleCopyClose()}
                    roleDetails={loadMore ? getList : []} />
                <DeleteModal onClose={(v) => handleDeleteModal(v)} id={roleId} loadTasks={() => loadTasks()} name={name} url={'role'} title={'Role'} visible={deleteModal} />
            </div>
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'Role'}
                type={'import'}
                loader={loader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={getList}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder) }}
            />
        </React.Fragment>
    )
}

export default SecurityRoles